import { createFileRoute } from '@tanstack/react-router'
import KohBusPaymentFailed from '@/components/make-booking/payment/PaymentFailed'

export const Route = createFileRoute('/make-booking/$id/payment/failed')({
  component: RouteComponent,
})

function RouteComponent() {
  return <KohBusPaymentFailed />
}
